import React, { useContext } from "react";
import "../App.css";
import { Redirect, useHistory } from "react-router-dom";
import logo from "../assets/logo.png";
import user from "../assets/user_white.png";
import { AuthContext } from "../context/AuthContext";

const Header = ({ toggleNav }) => {
  var history = useHistory();
  const { isLoggedIn } = useContext(AuthContext);

  if (!isLoggedIn) {
    console.log("logged out");
    let url = window.location.href;
    if (url.includes("?program=")) {
      console.log("PROGRAM");
      return <Redirect to="/download" />;
    } else if (url.includes("/download") || url.includes("/delete-account")) {
      // fine
    } else {
      console.log("LOGIN");
      return <Redirect to="/login" />;
    }
  }

  return (
    <div className="header" style={{ height: "10vh" }}>
      <div style={{ display: "flex", flex: 1, justifyContent: "flex-start", marginLeft: 10 }}>
        <img src={logo} style={{ width: 50, height: 50 }} />
        <div style={{ color: "white", alignSelf: "center", marginLeft: 10, fontWeight: "bold" }}>
          PCM Admin
        </div>
        <div style={{ display: "flex", flex: 1, justifyContent: "flex-end" }}>
          <img
            onClick={() => {
              console.log("click");
              history.push("/profile");
            }}
            src={user}
            style={{ width: 50, height: 50, marginRight: 10 }}
            className="icon-btn"
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
